import { Price } from 'swag-client-common/utils/price';
var HEADERS_TO_EXCLUDE = /*#__PURE__*/function (HEADERS_TO_EXCLUDE) {
  HEADERS_TO_EXCLUDE[HEADERS_TO_EXCLUDE["TAXES_AND_DUTIES"] = 5] = "TAXES_AND_DUTIES";
  return HEADERS_TO_EXCLUDE;
}(HEADERS_TO_EXCLUDE || {});
const TAX_EXCLUDED = Price.formatPriceCSV(0);
const shouldShowTaxColumn = (costs, taxColumnIndex) => {
  return costs.some(cost => cost[taxColumnIndex] !== TAX_EXCLUDED);
};
const filterCostsColumns = costRow => {
  return costRow.filter((_, index) => {
    return !Object.values(HEADERS_TO_EXCLUDE).includes(index);
  });
};
const filterHeaderColumns = (_, index) => {
  return !Object.values(HEADERS_TO_EXCLUDE).includes(index);
};
export const getDistributionFeeData = (headers, costs) => {
  const showTaxesHeader = shouldShowTaxColumn(costs, HEADERS_TO_EXCLUDE.TAXES_AND_DUTIES);
  const headerToShow = showTaxesHeader ? headers : headers.filter(filterHeaderColumns);
  const costsToShow = showTaxesHeader ? costs : costs.map(filterCostsColumns);
  return {
    headerToShow,
    costsToShow
  };
};